export const ACTIVE_CONTEXT_WARM_STATUSES = new Set(['queued', 'processing', 'warming', 'invalidated']);
export const WAITING_CONTEXT_WARM_STATUSES = new Set(['pending']);
export const TERMINAL_CONTEXT_WARM_STATUSES = new Set(['processed', 'failed', 'skipped', 'unavailable']);

export const normalizedWarmStatus = (row = {}) => String(row?.contextWarmStatus || (row?.contextWarmedAt || row?.warmedAt ? 'processed' : 'pending'))
  .trim()
  .toLowerCase();

export const warmFingerprint = (row = {}) => [
  normalizedWarmStatus(row),
  row?.contextWarmedAt || row?.warmedAt || '',
  row?.contextWarmError || '',
].join(':');

const hasProductLevelEvidence = (evidenceRows = {}) => Boolean(
  (evidenceRows.gmLineItems || []).length
  || (evidenceRows.cpqLineItems || []).length
  || (evidenceRows.historicalFinalGmLineItems || []).length
);

export const drawerEvidencePendingReason = ({ evidenceRows = {}, query = {}, row = {} } = {}) => {
  const warmStatus = normalizedWarmStatus(row);
  if ((query.isLoading || query.isFetching) && !query.data) return 'loading';
  if (ACTIVE_CONTEXT_WARM_STATUSES.has(warmStatus) && !hasProductLevelEvidence(evidenceRows)) return 'warming';
  if (WAITING_CONTEXT_WARM_STATUSES.has(warmStatus) && !hasProductLevelEvidence(evidenceRows)) return 'pending';
  return null;
};

export const drawerEvidencePending = (params = {}) => Boolean(drawerEvidencePendingReason(params));

export const refreshCompleteNotice = (warmStatus) => (
  warmStatus === 'skipped'
    ? 'Refresh skipped. The previous warmed snapshot remains visible.'
    : warmStatus === 'failed' || warmStatus === 'unavailable'
    ? 'Refresh finished with an error. The previous warmed snapshot remains visible.'
    : 'Refresh completed.'
);

export const shouldResolveQueuedRefreshNotice = ({
  warmStatus,
  baselineFingerprint,
  currentFingerprint,
  observedActive = false,
} = {}) => (
  TERMINAL_CONTEXT_WARM_STATUSES.has(warmStatus)
  && (observedActive || (baselineFingerprint && currentFingerprint && baselineFingerprint !== currentFingerprint))
);
